<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { usePostStore } from '@/Stores/PostStore'
import { storeToRefs } from 'pinia'

const postStore = usePostStore()
const { post } = storeToRefs(postStore)

const imgRef = ref(null)
const isVisible = ref(false)

let observer = null

onMounted(() => {
    if (imgRef.value) {
        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    isVisible.value = entry.isIntersecting
                })
            },
            { threshold: 0.1 }
        )
        observer.observe(imgRef.value)
    }
})

onUnmounted(() => {
    if (observer && imgRef.value) {
        observer.unobserve(imgRef.value)
        observer.disconnect()
    }
})
</script>

<template>
    <div ref="imgRef" class="max-w-auto h-full">
        <img
            :alt="post.title"
            :loading="isVisible ? 'eager' : 'lazy'"
            :src="post.media_url"
            class="w-full h-full object-cover rounded-lg"
        />
    </div>
</template>
